import { createAction } from 'redux-actions';

export const clearRelatedGuests = createAction('CLEAR_RELATED_GUESTS');
